<template>
  <div>

    <!-- Encabezado -->
    <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6">
      <div>
        <h2 class="text-2xl font-bold text-slate-800">Clientes</h2>
        <p class="text-slate-500 text-sm mt-1">Gestiona los clientes con acceso a los sistemas MADAV Solutions.</p>
      </div>
      <button
        @click="abrirNuevo"
        class="flex items-center gap-2 bg-emerald-600 hover:bg-emerald-700 text-white px-5 py-2.5 rounded-xl font-semibold text-sm shadow-lg shadow-emerald-200 transition-all duration-200 hover:scale-105 self-start sm:self-auto"
      >
        <i class="fa-solid fa-plus"></i>
        Nuevo Cliente
      </button>
    </div>

    <!-- Tabla -->
    <div class="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">
      <div class="overflow-x-auto">
        <table class="w-full text-sm">
          <thead>
            <tr class="bg-slate-50 border-b border-slate-200">
              <th class="px-6 py-4 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">#</th>
              <th class="px-6 py-4 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">Nombre</th>
              <th class="px-6 py-4 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">Correo electrónico</th>
              <th class="px-6 py-4 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">Rol</th>
              <th class="px-6 py-4 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">Estatus</th>
              <th class="px-6 py-4 text-left text-xs font-semibold text-slate-500 uppercase tracking-wider">Acciones</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-slate-100">

            <tr v-if="cargando">
              <td colspan="6" class="px-6 py-12 text-center text-slate-400">
                <i class="fa-solid fa-spinner fa-spin text-2xl text-emerald-400 mr-2"></i>
                Cargando...
              </td>
            </tr>

            <tr v-else-if="clientes.length === 0">
              <td colspan="6" class="px-6 py-12 text-center text-slate-400">
                <i class="fa-solid fa-inbox text-3xl mb-2 block"></i>
                No hay clientes registrados
              </td>
            </tr>

            <tr
              v-else
              v-for="(item, idx) in clientes"
              :key="item.idUsuario"
              class="hover:bg-slate-50 transition-colors duration-150"
            >
              <td class="px-6 py-4 text-slate-400 text-xs">{{ idx + 1 }}</td>

              <td class="px-6 py-4">
                <div class="flex items-center gap-3">
                  <div class="w-8 h-8 rounded-full bg-gradient-to-br from-emerald-400 to-green-600 flex items-center justify-center flex-shrink-0">
                    <span class="text-white text-xs font-bold">{{ iniciales(item.nombre) }}</span>
                  </div>
                  <span class="font-semibold text-slate-800">{{ item.nombre }}</span>
                </div>
              </td>

              <td class="px-6 py-4 text-slate-500">{{ item.email }}</td>

              <td class="px-6 py-4">
                <span class="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-semibold bg-blue-100 text-blue-700">
                  <i class="fa-solid fa-user text-xs"></i>
                  {{ item.nombreRol }}
                </span>
              </td>

              <td class="px-6 py-4">
                <span :class="['inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-semibold',
                               item.activo ? 'bg-emerald-100 text-emerald-700' : 'bg-red-100 text-red-600']">
                  <span :class="['w-1.5 h-1.5 rounded-full', item.activo ? 'bg-emerald-500' : 'bg-red-500']"></span>
                  {{ item.activo ? 'Activo' : 'Inactivo' }}
                </span>
              </td>

              <td class="px-6 py-4">
                <div class="flex items-center gap-2">
                  <button
                    @click="editar(item)"
                    class="p-2 rounded-lg bg-emerald-50 hover:bg-emerald-100 text-emerald-600 transition-colors duration-150"
                    title="Editar"
                  >
                    <i class="fa-solid fa-pen-to-square text-xs"></i>
                  </button>
                  <button
                    @click="cambiarEstatus(item)"
                    :class="['p-2 rounded-lg transition-colors duration-150',
                             item.activo
                               ? 'bg-red-50 hover:bg-red-100 text-red-500'
                               : 'bg-emerald-50 hover:bg-emerald-100 text-emerald-600']"
                    :title="item.activo ? 'Desactivar' : 'Activar'"
                  >
                    <i :class="['text-xs', item.activo ? 'fa-solid fa-ban' : 'fa-solid fa-check']"></i>
                  </button>
                </div>
              </td>
            </tr>

          </tbody>
        </table>
      </div>
    </div>

    <!-- Modal -->
    <transition name="modal">
      <div v-if="modalVisible" class="fixed inset-0 z-50 flex items-center justify-center modal-overlay p-4">
        <div class="bg-white rounded-2xl shadow-2xl w-full max-w-lg animate-fade-in">

          <!-- Header modal -->
          <div class="flex items-center justify-between px-6 py-5 border-b border-slate-100">
            <h3 class="font-bold text-slate-800 text-lg">
              <i class="fa-solid fa-user-plus text-emerald-500 mr-2"></i>
              {{ modoEdicion ? 'Editar Cliente' : 'Nuevo Cliente' }}
            </h3>
            <button @click="cerrarModal" class="text-slate-400 hover:text-slate-600 p-1">
              <i class="fa-solid fa-xmark text-lg"></i>
            </button>
          </div>

          <!-- Cuerpo modal -->
          <div class="px-6 py-5 space-y-4">

            <div>
              <label class="block text-sm font-semibold text-slate-700 mb-1">
                Nombre completo <span class="text-red-500">*</span>
              </label>
              <input
                v-model="form.nombre"
                type="text"
                maxlength="100"
                placeholder="Ej. Juan Pérez García"
                class="w-full border border-slate-300 rounded-xl px-4 py-2.5 text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-emerald-400 focus:border-transparent transition-all"
              />
            </div>

            <div>
              <label class="block text-sm font-semibold text-slate-700 mb-1">
                Correo electrónico <span class="text-red-500">*</span>
              </label>
              <input
                v-model="form.email"
                type="email"
                maxlength="150"
                placeholder="correo@ejemplo.com"
                class="w-full border border-slate-300 rounded-xl px-4 py-2.5 text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-emerald-400 focus:border-transparent transition-all"
              />
            </div>

            <div>
              <label class="block text-sm font-semibold text-slate-700 mb-1">
                Contraseña
                <span v-if="!modoEdicion" class="text-red-500">*</span>
                <span v-else class="text-slate-400 font-normal text-xs ml-1">(dejar vacío para no cambiar)</span>
              </label>
              <div class="relative">
                <input
                  v-model="form.password"
                  :type="mostrarPassword ? 'text' : 'password'"
                  maxlength="100"
                  :placeholder="modoEdicion ? '�?��?��?��?��?��?��?��?�' : 'Mínimo 6 caracteres'"
                  class="w-full border border-slate-300 rounded-xl px-4 py-2.5 pr-11 text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-emerald-400 focus:border-transparent transition-all"
                />
                <button
                  type="button"
                  @click="mostrarPassword = !mostrarPassword"
                  class="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600 transition"
                  tabindex="-1"
                >
                  <i :class="mostrarPassword ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'" class="text-sm"></i>
                </button>
              </div>
            </div>

          </div>

          <!-- Footer modal -->
          <div class="flex justify-end gap-3 px-6 py-4 border-t border-slate-100">
            <button
              @click="cerrarModal"
              class="px-5 py-2.5 rounded-xl border border-slate-300 text-slate-600 font-semibold text-sm hover:bg-slate-50 transition-all"
            >Cancelar</button>
            <button
              @click="guardar"
              :disabled="guardando"
              class="px-5 py-2.5 rounded-xl bg-emerald-600 hover:bg-emerald-700 text-white font-semibold text-sm shadow-lg shadow-emerald-200 transition-all duration-200 hover:scale-105 disabled:opacity-60 disabled:cursor-not-allowed"
            >
              <i v-if="guardando" class="fa-solid fa-spinner fa-spin mr-1"></i>
              {{ guardando ? 'Guardando...' : 'Guardar' }}
            </button>
          </div>

        </div>
      </div>
    </transition>

  </div>
</template>

<script>
import servicio from '@/services/clientes.service'

export default {
  name: 'ClientesAdmin',
  data () {
    return {
      clientes:      [],
      cargando:      false,
      guardando:     false,
      modalVisible:  false,
      modoEdicion:   false,
      mostrarPassword: false,
      form: {
        idUsuario: 0,
        nombre:    '',
        email:     '',
        password:  '',
        activo:    true
      }
    }
  },
  mounted () {
    this.cargar()
  },
  methods: {
    iniciales (nombre) {
      return nombre
        .split(' ')
        .slice(0, 2)
        .map(p => p[0])
        .join('')
        .toUpperCase()
    },

    async cargar () {
      this.cargando = true
      try {
        const res = await servicio.clientesCon()
        this.clientes = res.data.clientes || []
      } catch {
        this.$store.dispatch('mostrarToast', { mensaje: 'Error al cargar clientes', tipo: 'error' })
      } finally {
        this.cargando = false
      }
    },

    abrirNuevo () {
      this.modoEdicion        = false
      this.mostrarPassword    = false
      this.form.idUsuario     = 0
      this.form.nombre        = ''
      this.form.email         = ''
      this.form.password      = ''
      this.form.activo        = true
      this.modalVisible       = true
    },

    editar (item) {
      this.modoEdicion        = true
      this.mostrarPassword    = false
      this.form.idUsuario     = item.idUsuario
      this.form.nombre        = item.nombre
      this.form.email         = item.email
      this.form.password      = ''
      this.form.activo        = item.activo
      this.modalVisible       = true
    },

    cerrarModal () {
      this.modalVisible = false
    },

    async guardar () {
      if (!this.form.nombre.trim()) {
        this.$store.dispatch('mostrarToast', { mensaje: 'El nombre es obligatorio', tipo: 'warning' })
        return
      }
      if (!this.form.email.trim()) {
        this.$store.dispatch('mostrarToast', { mensaje: 'El correo electrónico es obligatorio', tipo: 'warning' })
        return
      }
      if (!this.modoEdicion && !this.form.password.trim()) {
        this.$store.dispatch('mostrarToast', { mensaje: 'La contraseña es obligatoria', tipo: 'warning' })
        return
      }

      this.guardando = true
      try {
        const res = await servicio.guardar(this.form)
        if (res.data.resultado) {
          this.cerrarModal()
          this.$store.dispatch('mostrarToast', { mensaje: res.data.mensaje, tipo: 'success' })
          await this.cargar()
        } else {
          this.$store.dispatch('mostrarToast', { mensaje: res.data.mensaje, tipo: 'warning' })
        }
      } catch {
        this.$store.dispatch('mostrarToast', { mensaje: 'Error al guardar el cliente', tipo: 'error' })
      } finally {
        this.guardando = false
      }
    },

    async cambiarEstatus (item) {
      const nuevoActivo = !item.activo
      try {
        const res = await servicio.cambiarEstatus({ idUsuario: item.idUsuario, activo: nuevoActivo })
        if (res.data.resultado) {
          this.$store.dispatch('mostrarToast', { mensaje: res.data.mensaje, tipo: 'success' })
          await this.cargar()
        } else {
          this.$store.dispatch('mostrarToast', { mensaje: res.data.mensaje, tipo: 'warning' })
        }
      } catch {
        this.$store.dispatch('mostrarToast', { mensaje: 'Error al cambiar estatus', tipo: 'error' })
      }
    }
  }
}
</script>
